import { cn } from '@/lib/utils/cn';

/**
 * Retraced pin mark (brand logo, not a UI icon) — rendered from a single
 * vector path so it can be recolored via `currentColor` (e.g. white on
 * the dark-teal side rail).
 */
export function RetracedMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox='0 0 141 199'
      fill='currentColor'
      role='img'
      aria-label='Retraced'
      className={cn('shrink-0', className)}
    >
      <path d='M71,198.5l-8.3-8.6c0.7-0.6,65.7-64.1,65.7-119.7c0-32.1-26.1-58.2-58.2-58.2C38.1,12,12,38.1,12,70.2 c0,33.3,27.3,74.9,37.9,89.9c5.4-5.9,14.3-16.2,22.9-27.6c17.6-23.6,26.5-43.2,26.5-58.2c0-16.1-13.1-29.2-29.2-29.2 S41,58.1,41,74.2c0,5.3,1.2,19.6,12,38.6c0.8,1.4,1.6,2.8,2.5,4.3l-10.2,6.3c-1-1.6-1.9-3.2-2.8-4.7C30.8,98.1,29,82,29,74.2 c0-22.7,18.5-41.2,41.2-41.2c22.7,0,41.2,18.5,41.2,41.2c0,17.7-9.7,39.7-28.9,65.4c-13.7,18.3-28.1,33.4-28.7,34l-4.8,5l-4.3-5.5 C42.9,170.8,0,115.5,0,70.2C0,31.5,31.5,0,70.2,0c38.7,0,70.2,31.5,70.2,70.2c0,25.7-11.7,55.2-34.9,87.6 C88.5,181.6,71.7,197.9,71,198.5z' />
    </svg>
  );
}
